import React, {useEffect, useState} from "react";
import {getBankInformation, getCardData, postPayment} from "../../services/payment-service";
import Swal from "sweetalert2";
import {Field, Form, Formik} from 'formik';

export default function PaymentCardForm(props) {


    //Setting "Vencimiento" MM // YY
    const currentTime = new Date();
    const year = currentTime.getFullYear();
    const [cvvVisible, setcCvvVisible] = useState(false);
    const visibleCVV = () => {
        setcCvvVisible(!cvvVisible);
    };

    let yearsArray = [];
    for (let i = year; i <= year + 20; i += 1) yearsArray.push(i);
    let monthsArray = [];
    for (let i = 1; i <= 12; i += 1) monthsArray.push(i);
    let [bankInformation, setBackInformation] = useState([])

    //Use efect:
    useEffect( () => {
        getBankInformation().then(data => {
            setBackInformation(data)
        });
    }, [])

    return (
        <>
            <Formik initialValues={props.formikInitialValues}
                    onSubmit={(values,) => {
                        let cardData;
                        cardData = {
                            "receiptId": props.receiptData.receiptId,
                            "workOrderId": props.receiptData.workOrderId,
                            "insuranceCompanyId": props.receiptData.insuranceCompanyId,
                            "bank": values.bankId,
                            "cardNumber": values.cardNumber,
                            "cvv": values.cvv,
                            "ownerCardName": values.ownerCardName,
                            "endDateMonth": values.dateEndMM,
                            "endDateYear": values.dateEndYY,
                            "amount": props.receiptData.totalPremium,
                        }
                        //Loading alert while services respond
                        return Swal.fire({
                            title: 'Realizando pago...',
                            text: 'Esto puede tardar algunos segundos',
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            didOpen: () => {
                                Swal.showLoading();
                                /* Calling external service sending first 6 digist of the card
                                * to detect the Bank and card type */
                                return postPayment(cardData)
                                    .then(response => {
                                        console.log(response)
                                    //If payment OK returning success alert with referenceNumber & authorizationNumber.
                                        Swal.fire({
                                            icon: 'success',
                                            iconColor: 'var(--skrSecondary)',
                                            title: 'Pago Exitoso',
                                            text: 'Se completó satisfactoriamente el pago',
                                            backdrop: `rgba(71, 10, 104, .75)`,
                                            allowOutsideClick: false,
                                            html: '<p class="panel list-group text-center">' +
                                                '<div class="list-group-item">' +
                                                '<label>' +
                                                '<strong><u> Número de autorización: </u>' +
                                                '</strong>' +
                                                '</label>' +
                                                '<h6 class="mt-1">' + response.insuranceResponse.authorizationNumber + '</h6>' +
                                                '</div>' +
                                                '<div class="list-group-item">' +
                                                '<label>' +
                                                '<strong><u> Número de referencia: </u>' +
                                                '</strong>' +
                                                '</label>' +
                                                '<h6 class="mt-1">' + response.reference + '</h6>' +
                                                '</div>',
                                            confirmButtonColor: 'var(--skrSecondary)',
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                window.location = '/#/consulta'
                                            }
                                        })
                                }).catch(() => {
                                    //If postPayment throws error...
                                    Swal.fire({
                                        icon: 'error',
                                        iconColor: 'var(--skrSecondary)',
                                        title: 'Pago Fallido',
                                        backdrop: `rgba(71, 10, 104, .75)`,
                                        text: 'Contacta a tu ejecutivo',
                                        confirmButtonColor: 'var(--skrSecondary)',
                                    })
                                });
                            }
                        })
                    }
                    }>

                {({values, handleChange}) => (

                    <div className="col">
                        <Form id="paymentForm" onChange={handleChange}>
                            {/* Select para la información de las tarjetas*/}
                            <div className="form-group">
                                <select name="bankId" className="form-control form-select" placeholder="Nombre del Banco" required>
                                    <option value="" selected disabled>
                                        Nombre del Banco
                                    </option>
                                    {
                                        //Para hacer la inyección del código de HTML en un map se usa "("
                                        bankInformation.map(element => (
                                            <option key={element.idBank} value={element.idBank}>
                                                {element.description}
                                            </option>

                                        ))
                                    }
                                    {/* En este momento se llena con la consulta*/}
                                </select>
                            </div>
                            {/* Select para la información de las tarjetas*/}

                            <div className="form-group mt-2">
                                <input name="ownerCardName" type="text" className="form-control"
                                       placeholder="Nombre del titular de la tarjeta"
                                       required/>
                            </div>
                            <div className="form-group mt-2">
                                <input name="cardNumber" type="text" maxLength="19" minLength="15"
                                       className="form-control" pattern="^[0-9]+$"
                                       placeholder="Número de tarjeta" required/>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-6">
                                    <div className="form-group mt-2">
                                        <select name="dateEndMM" className="form-control form-select" placeholder="MM / YY" required>
                                            <option value="" selected disabled>
                                                Mes de vencimiento
                                            </option>
                                            {monthsArray.map(option => (
                                                <option key={option} value={option}>
                                                    {option.toLocaleString('en-US', {
                                                        minimumIntegerDigits: 2,
                                                        useGrouping: false
                                                    })}
                                                </option>))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <div className="form-group mt-2">
                                        <select name="dateEndYY" className="form-control form-select" placeholder="MM / YY" required>
                                            <option value="" selected disabled>
                                                Año de vencimiento
                                            </option>
                                            {yearsArray.map(option => (
                                                <option key={option} value={option}>
                                                    {option}
                                                </option>))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <div className="form-group mt-2">
                                        <div className="input-group mb-2">
                                        <input name="cvv" type={cvvVisible ? "text" : "password"} maxLength="4" minLength="3"
                                               min="3" max="4" pattern="^[0-9]+$"
                                               className="form-control border-end-0" placeholder="CVV / CVC" required/>
                                        <div className="input-group-prepend">
                                        <span data-toggle="tooltip"
                                              title="Ver o esconder CVV/CVC"
                                              className="input-group-text bg-transparent border-start-0" role="button"
                                              onClick={visibleCVV}>
                                                <i className="bi bi-eye-fill text-secondary"></i>
                                            </span>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-3 text-center" hidden={!props.isSubmitOn}>
                                <button type="submit" form="myform"
                                        className="btn btn-skr-secondary mb-1 px-4 float-end">
                                    <i className="bi-credit-card"></i> Pagar
                                </button>
                            </div>
                        </Form>

                    </div>
                )}
            </Formik>
        </>
    )
}